import api from '_config/travel'

export function getAirports(airports) {
    return api.get(`flights/geolocation?word=${airports}`)
        .then(response => {
            if (response.status === 200) {
                return response.data;
            }

        })
        .catch(error => console.log(error))
}

export function getMostSearchedAirports(param) {
    return api.get('flights/recent-searches', { params: {
        customer_uuid: param.customer_uuid ? btoa(param.customer_uuid) : ''
    }})
        .then(response => {
            if (response.status === 200) {
                return response.data;
            }
        })
        .catch(error => console.log(error))
}

export function getTopResearches() {
    return api.get('flights/trending-destinations')
        .then(response => {
            if (response.status === 200) {
                return response.data;
            }

        })
        .catch(error => console.log(error))
}
